enum DispatchGuardTypes {
	Roaming  = 1,
    Static = 2,
    Bicycle = 3,
    Car = 4,
    Assessor = 100,
}

export default DispatchGuardTypes;